// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useContext } from 'react';
import { getMultilangs } from '../../common/Multilang';
import CommonContext from '../../../contexts/CommonContext';

import { S } from './styles';
import { FormattedMessage } from 'react-intl';

interface SearchConditionProps {
  selectedPlatformId: number;
  selectedDomainIds: number[];
  updateSelectedPlatformId: (nextPlatform: number) => void;
  updateSelectedDomainIds: (nextDomain: number[]) => void;
}

function SearchCondition(props: SearchConditionProps): JSX.Element {
  const {
    selectedPlatformId,
    selectedDomainIds,
    updateSelectedPlatformId,
    updateSelectedDomainIds
  } = props;
  const { domains, platforms } = useContext(CommonContext);
  const platformsCondition = getMultilangs(platforms).sort((a, b) => a.name >= b.name ? 1 : -1);
  const domainsCondition = getMultilangs(domains).sort((a, b) => a.name >= b.name ? 1 : -1);

  function handleSelectPlatform(selectedId: number) {
    if (selectedPlatformId === selectedId) {
      updateSelectedPlatformId(0)
    } else {
      updateSelectedPlatformId(selectedId)
    }
  }

  function handleSelectDomain(selectedId: number) {
    const isSelected = selectedDomainIds.indexOf(selectedId) !== -1;
    if (isSelected) {
      updateSelectedDomainIds(selectedDomainIds.filter(key => key !== selectedId))
    } else {
      updateSelectedDomainIds([...selectedDomainIds, selectedId])
    }
  }

  return (
    <S.Container>
      <S.Title>
        <FormattedMessage id="C003" />
      </S.Title>
      <S.ConditionsContainer>
        {
          platformsCondition.map((platform, index) => {
            const isSelected = selectedPlatformId === platform.id;
            return (
              <S.Condition
                key={index}
                isSelected={isSelected}
                onClick={() => handleSelectPlatform(platform.id)}
              >
                <S.ConditionTitle>{platform.name}</S.ConditionTitle>
                {isSelected && <S.ConditionCancelButton />}
              </S.Condition>
            )
          })
        }
        {
          domainsCondition.map((domain, index) => {
            const isSelected = selectedDomainIds.indexOf(domain.id) !== -1;
            return (
              <S.Condition
                key={index}
                isSelected={isSelected}
                onClick={() => handleSelectDomain(domain.id)}
              >
                <S.ConditionTitle>{domain.name}</S.ConditionTitle>
                {isSelected && <S.ConditionCancelButton />}
              </S.Condition>
            )
          })
        }
      </S.ConditionsContainer>

    </S.Container>
  )
}

export { SearchCondition as default };
